import { Injectable } from '@angular/core';
import { BaseService, RequestOptions } from 'src/app/services/base.service';
import { Observable } from 'rxjs';
import { FilePathCollection } from 'src/app/models/file/file-collection';
import { FilesDataExportQueryFilter, ForecastDataExport, ForecastPeriod } from '../models/forecast/topdown-adjustment.model';
import { GeneralSetting } from '../pages/settings/settings.service';
import { ExportData, ExportPeriod } from '../models/filter-objects';

@Injectable({
	providedIn: 'root'
})
export class FileExportService {

	private static readonly REQUEST_TOP_PATH: string = "FileUpload";

	constructor(
		private baseService: BaseService
	) { }

	public DownloadFile(
		fileName: FilePathCollection,
		requestOptions?: RequestOptions
	): Observable<File> {
		const requestEndpoint: string = "GetBlobDownload";

		let url = `${FileExportService.REQUEST_TOP_PATH}/${requestEndpoint}?Type=${fileName.LinkType}&FileName=${encodeURIComponent(fileName.FileName)}`;

		return this.baseService.getBlob(
			url,
			requestOptions
		);
	}

	public GetExportData(
		data: ForecastDataExport,
		requestOptions?: RequestOptions
	): Observable<any> {
		const requestEndpoint: string = "GetExportData";

		let url = `${FileExportService.REQUEST_TOP_PATH}/${requestEndpoint}`;

		return this.baseService.post<any>(
			url,
			data,
			requestOptions
		);
	}

	public GetExportFilterOptionData(
		data: FilesDataExportQueryFilter,
		requestOptions?: RequestOptions
	): Observable<any> {
		const requestEndpoint: string = "GetExportFilterOptionData";

		let url = `${FileExportService.REQUEST_TOP_PATH}/${requestEndpoint}`;

		return this.baseService.post<any>(
			url,
			data,
			requestOptions
		);
	}

	public GetExportPeriod(
		action: string,
		requestOptions?: RequestOptions
	): Observable<ForecastPeriod[]> {
		const requestEndpoint: string = "GetExportPeriod";

		let url = `${FileExportService.REQUEST_TOP_PATH}/${requestEndpoint}?action=${action}`;

		return this.baseService.post<ForecastPeriod[]>(
			url,
			requestOptions
		);
	}

	WebSettings(action: string, requestOptions?: RequestOptions) {
		return this.baseService.post<GeneralSetting>("Settings/WebSettings?action=" + action, undefined, requestOptions);
	}

	WebSettingsPivot(action: string, requestOptions?: RequestOptions) {
		return this.baseService.post<any>("Settings/WebMulSettings?action=" + action, undefined, requestOptions);
	}

	ExportToFile(
		data: ExportData,
		requestOptions?: RequestOptions
	): Observable<any> {
		let url = `${FileExportService.REQUEST_TOP_PATH}/ExportToFile`;
		return this.baseService.post<any>(url, data, requestOptions);
	}

	ExportPeriodData(action, requestOptions?: RequestOptions): Observable<ExportPeriod[]> {
		return this.baseService.post<ExportPeriod[]>(`${FileExportService.REQUEST_TOP_PATH}/ExportPeriodData?action=${action}`, requestOptions);
	}
}
